function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.412 10.102c-.014 1.003.962 1.562 1.697 1.895.756.342 1.01.56 1.006.866-.005.467-.602.673-1.16.681-.975.014-1.541-.244-1.992-.44l-.35 1.527c.451.193 1.288.362 2.155.369 2.037 0 3.37-.934 3.377-2.382.008-1.838-2.736-1.94-2.718-2.761.007-.25.263-.515.823-.583.278-.034 1.044-.06 1.912.312l.341-1.477a5.55 5.55 0 0 0-1.815-.309c-1.917 0-3.265.947-3.276 2.302zm8.367-2.175a.887.887 0 0 0-.826.511l-2.909 6.454h2.035l.405-1.04h2.487l.235 1.04H24l-1.565-6.965h-1.656zm.284 1.882l.588 2.615h-1.609l1.021-2.615zM9.945 7.927L8.34 14.892h1.94l1.603-6.965H9.945zm-2.87 0l-2.018 4.74-.817-4.03c-.095-.45-.474-.71-.894-.71h-3.3L0 8.13c.677.137 1.447.357 1.913.593.286.144.367.27.46.612l1.548 5.558H5.97l3.142-6.965H7.076",
  fill: "url(#visa_svg__paint0_linear_3437_7390)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "visa_svg__paint0_linear_3437_7390",
  x1: 11.034,
  y1: 15.144,
  x2: 11.227,
  y2: 7.749,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#222357"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#254AA5"
})));

var SvgVisa = function SvgVisa(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/visa.3e728d51.svg";
export { SvgVisa as ReactComponent };